// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"23e0cdd6","551":"805de37b","842":"cd6d22e3","977":"b9e7a307"}[chunkId] + ".chunk.js";
};